import { __spreadArray } from "tslib";
import * as React from 'react';
import { create } from 'jss';
import ScopedCssBaseline from '@material-ui/core/ScopedCssBaseline';
import CssBaseline from '@material-ui/core/CssBaseline';
import { StylesProvider, jssPreset } from '@material-ui/core/styles';
import jssRtl from 'jss-rtl';
import memoize from 'lodash/memoize';
import { BbThemeProvider } from '../BbThemeProvider';
import pxToRem from '../../internal/utilities/px-to-rem';
export var getJssInstance = memoize(function (jssInsertionPoint) {
    return create({
        plugins: __spreadArray(__spreadArray([], jssPreset().plugins, true), [pxToRem(), jssRtl()], false),
        insertionPoint: jssInsertionPoint,
    });
});
export var JssThemeProvider = function (props) {
    var children = props.children, theme = props.theme, jssInsertionPoint = props.jssInsertionPoint, cssReset = props.cssReset, isRtl = props.isRtl, generateClassName = props.generateClassName, zIndex = props.zIndex;
    var jss = React.useMemo(function () { return getJssInstance(jssInsertionPoint); }, [jssInsertionPoint]);
    return (React.createElement(StylesProvider, { jss: jss, generateClassName: generateClassName },
        React.createElement(BbThemeProvider, { theme: theme, isRtl: isRtl, zIndex: zIndex },
            (!cssReset || cssReset === 'global') && (React.createElement(React.Fragment, null,
                React.createElement(CssBaseline, null),
                children)),
            cssReset === 'scoped' && React.createElement(ScopedCssBaseline, null, children),
            cssReset === 'none' && children)));
};
export default JssThemeProvider;
//# sourceMappingURL=JssThemeProvider.js.map